import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';

interface Props {
  contactName: string | undefined;
  contactOccupation: string | undefined;
  assessment: Assessment | undefined;
}

const ContactPersona: React.FC<Props> = ({ contactName, contactOccupation, assessment }) => {
  const { classes } = useStyles();

  const motiveIllustrationGenerator = () => {
    const baseUrl = '/dashboard/images/illustrations/';

    const motive = assessment?.name || '';

    return `${baseUrl}${_.replace(_.toLower(motive), ' ', '')}.png`;
  };

  return (
    <Stack gap={1} direction={'row'} alignItems={'flex-start'}>
      {!_.isNil(contactName) || !_.isNil(contactOccupation) ? (
        <div className={classes.card}>
          <div>
            <Typography className={classes.contactName}>{contactName || '-'}</Typography>
            <Typography className={classes.occupation} textAlign={'center'}>
              {!_.isNil(contactOccupation) ? `- ${contactOccupation} -` : '- no profession -'}
            </Typography>
          </div>
        </div>
      ) : null}
      {!_.isNil(assessment) ? (
        <div className={classes.card} style={{ display: 'flex', justifyContent: 'center' }}>
          <img className={classes.illustration} src={motiveIllustrationGenerator()} alt="motive illustration" />
        </div>
      ) : null}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  card: {
    width: '100%',
    padding: '20px',
    background: '#FFF',
    borderRadius: '8px',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contactName: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '4px',
    textTransform: 'capitalize',
  },
  occupation: {
    width: '100%',
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 900,
    color: theme.palette.primary.main,
  },
  illustration: {
    width: 'auto',
    height: '145px',
  },
}));

export default ContactPersona;
